module.exports = __webpack_public_path__ + "img/Support-skill-426.ead6bfde.png";